// Helper centralizado para recuperar o usuário logado do localStorage
// Mantém tipagem fraca para evitar dependências circulares; pode ser expandido depois.
export interface CurrentUserLike {
  userId?: string | number
  name?: string
  [key: string]: any
}

export function getCurrentUser(): CurrentUserLike | null {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && parsed.userId !== undefined && parsed.userId !== null) {
      return parsed
    }
    return null
  } catch {
    return null
  }
}

export function getCurrentUserId(): string | number | null {
  const user = getCurrentUser()
  return user?.userId ?? null
}
